const mutation = {
  api: "appliance",
  type: "mutation",
} as const;

export const ApplianceMutationKeys = {
  bulkMove: () => [mutation, { action: "bulk-move-appliances" }] as const,
};
